// extracted by mini-css-extract-plugin
module.exports = {"container":"i_FA","heading":"i_FB","main":"i_FC"};